import { PayloadAction } from '@reduxjs/toolkit'
import { AddressTypes, IActionAddressRequest } from './types'
import { AddressActions } from './index'
import { all, apply, put, select, takeLatest } from 'redux-saga/effects'
import addressService from '../../services/address.service'
import { SnackbarActions, SnackBarMessageType } from '../snackbar'
import { ApplicationState, AsyncStateStatus } from '../root.types'

export function* requestPerson(action: PayloadAction<IActionAddressRequest>) {
    const { addressPersonSuccess, addressPersonFailure } = AddressActions
    const { openSnackBar } = SnackbarActions
    try {
        const { filters } = action.payload
        const data: any = yield apply(addressService, addressService.getAddressPerson, [filters])
        const status: AsyncStateStatus = yield select((state: ApplicationState) => state.address.person.status)
        if (status !== AsyncStateStatus.LOADING) return
        yield put(addressPersonSuccess({ data }))
    } catch (err: any) {
        const status: AsyncStateStatus = yield select((state: ApplicationState) => state.address.person.status)
        if (status !== AsyncStateStatus.LOADING) return
        yield put(addressPersonFailure())
        yield put(openSnackBar({ type: SnackBarMessageType.ERROR, title: 'Erro.', message: 'Ocorreu um erro ao buscar endereços de pessoas.' }))
    }
}

export function* requestCompany(action: PayloadAction<IActionAddressRequest>) {
    const { addressCompanySuccess, addressCompanyFailure } = AddressActions
    const { openSnackBar } = SnackbarActions
    try {
        const { filters } = action.payload
        const data: any = yield apply(addressService, addressService.getAddressCompany, [filters])
        const status: AsyncStateStatus = yield select((state: ApplicationState) => state.address.company.status)
        if (status !== AsyncStateStatus.LOADING) return
        yield put(addressCompanySuccess({ data }))
    } catch (err: any) {
        const status: AsyncStateStatus = yield select((state: ApplicationState) => state.address.company.status)
        if (status !== AsyncStateStatus.LOADING) return
        yield put(addressCompanyFailure())
        yield put(openSnackBar({ type: SnackBarMessageType.ERROR, title: 'Erro.', message: 'Ocorreu um erro ao buscar endereços de empresas.' }))
    }
}

export function* requestGeometryPerson(action: PayloadAction<IActionAddressRequest>) {
    const { addressPersonGeometrySuccess, addressPersonGeometryFailure } = AddressActions
    const { openSnackBar } = SnackbarActions
    try {
        const { filters } = action.payload
        const data: any = yield apply(addressService, addressService.getAddressGeometryPerson, [filters])
        const status: AsyncStateStatus = yield select((state: ApplicationState) => state.address.geometryPerson.status)
        if (status !== AsyncStateStatus.LOADING) return
        yield put(addressPersonGeometrySuccess({ data }))
    } catch (err: any) {
        const status: AsyncStateStatus = yield select((state: ApplicationState) => state.address.geometryPerson.status)
        if (status !== AsyncStateStatus.LOADING) return
        yield put(addressPersonGeometryFailure())
        yield put(openSnackBar({ type: SnackBarMessageType.ERROR, title: 'Erro.', message: 'Ocorreu um erro ao buscar geometria de pessoas.' }))
    }
}

export function* requestGeometryCompany(action: PayloadAction<IActionAddressRequest>) {
    const { addressCompanyGeometrySuccess, addressCompanyGeometryFailure } = AddressActions
    const { openSnackBar } = SnackbarActions
    try {
        const { filters } = action.payload
        const data: any = yield apply(addressService, addressService.getAddressGeometryCompany, [filters])
        const status: AsyncStateStatus = yield select((state: ApplicationState) => state.address.geometryCompany.status)
        if (status !== AsyncStateStatus.LOADING) return
        yield put(addressCompanyGeometrySuccess({ data }))
    } catch (err: any) {
        const status: AsyncStateStatus = yield select((state: ApplicationState) => state.address.geometryCompany.status)
        if (status !== AsyncStateStatus.LOADING) return
        yield put(addressCompanyGeometryFailure())
        yield put(openSnackBar({ type: SnackBarMessageType.ERROR, title: 'Erro.', message: 'Ocorreu um erro ao buscar geometria de empresas.' }))
    }
}

const addressSaga = function* () {
    yield all([
        takeLatest(AddressTypes.ADDRESS_PERSON_REQUEST, requestPerson),
        takeLatest(AddressTypes.ADDRESS_COMPANY_REQUEST, requestCompany),
        takeLatest(AddressTypes.ADDRESS_PERSON_GEOMETRY_REQUEST, requestGeometryPerson),
        takeLatest(AddressTypes.ADDRESS_COMPANY_GEOMETRY_REQUEST, requestGeometryCompany),
    ])
}

export default addressSaga
